import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxSwitchModule, DxTagBoxModule } from 'devextreme-angular';
import { DxAccordionModule } from 'devextreme-angular';
import { DxButtonModule } from 'devextreme-angular';
import { DxButtonGroupModule } from 'devextreme-angular';
import { DxChartModule } from 'devextreme-angular';
import { DxCheckBoxModule } from 'devextreme-angular';
import { DxDataGridModule } from 'devextreme-angular';
import { DxDateBoxModule } from 'devextreme-angular';
import { DxDropDownBoxModule } from 'devextreme-angular';
import { DxDropDownButtonModule } from 'devextreme-angular';
import { DxFormModule } from 'devextreme-angular';
import { DxHtmlEditorModule } from 'devextreme-angular';
import { DxListModule } from 'devextreme-angular';
import { DxLoadIndicatorModule } from 'devextreme-angular';
import { DxLoadPanelModule } from 'devextreme-angular';
import { DxLookupModule } from 'devextreme-angular';
import { DxNumberBoxModule } from 'devextreme-angular';
import { DxPopoverModule } from 'devextreme-angular';
import { DxPopupModule } from 'devextreme-angular';
import { DxRadioGroupModule } from 'devextreme-angular';
import { DxScrollViewModule } from 'devextreme-angular';
import { DxSelectBoxModule } from 'devextreme-angular';
import { DxSpeedDialActionModule } from 'devextreme-angular';
import { DxTabPanelModule } from 'devextreme-angular';
import { DxTextAreaModule } from 'devextreme-angular';
import { DxTextBoxModule } from 'devextreme-angular';
import { DxToolbarModule } from 'devextreme-angular';
import { DxTooltipModule } from 'devextreme-angular';
import { DxTreeListModule } from 'devextreme-angular';
import { DxValidatorModule } from 'devextreme-angular';
import { SingleCardModule } from '../../shared/components/single-card/single-card.component';
import { SharedModule } from '../../shared/shared.module';
import { ResultsRoutingModule } from '../results/results-routing.module';
import { StandingOrderDoneDialogComponent } from './components/standing-order-done-dialog/standing-order-done-dialog.component';
import { StandingOrderSearchContentComponent } from './components/standing-order-search-content/standing-order-search-content.component';
import { StandingOrderFormComponent } from './pages/standing-order-form/standing-order-form.component';
import { StandingOrderSearchComponent } from './pages/standing-order-search/standing-order-search.component';
import { StandingOrdersRoutingModule } from './standing-orders-routing.module';


@NgModule({
    declarations: [
        StandingOrderDoneDialogComponent,
        StandingOrderFormComponent,
        StandingOrderSearchContentComponent,
        StandingOrderSearchComponent,
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        DxTextBoxModule,
        DxSelectBoxModule,
        DxValidatorModule,
        DxTreeListModule,
        DxPopupModule,
        DxDateBoxModule,
        DxHtmlEditorModule,
        DxButtonModule,
        DxTextAreaModule,
        DxAccordionModule,
        DxLookupModule,
        DxNumberBoxModule,
        DxChartModule,
        DxCheckBoxModule,
        DxTabPanelModule,
        DxFormModule,
        DxScrollViewModule,
        DxPopoverModule,
        DxListModule,
        DxTooltipModule,
        DxToolbarModule,
        DxLoadPanelModule,
        DxButtonGroupModule,
        DxLookupModule,
        DxSpeedDialActionModule,
        DxRadioGroupModule,
        DxDropDownButtonModule,
        DxDropDownBoxModule,
        DxLoadIndicatorModule,
        DxDataGridModule,
        DxTagBoxModule,
        DxSwitchModule,
        StandingOrdersRoutingModule,
        SharedModule,
        SingleCardModule,
    ],
})
export class StandingOrdersModule {
}
